import request from '@/utils/request';

// 账号密码登录
export function getLoginPassword(account, password){
  const data = {
    account,
    password,
  };
  return request({
    method: 'post',
    url: '/fenydata-java-console/api/0/v1/login/accountLogin',
    data,
  });
}

// 手机验证码登录
export function getPhoneLogin(data){
  return request({
    method: 'post',
    url: '/fenydata-java-console/api/0/v1/login/phoneLogin',
    data: data,
  });
}

// 验证码生成
export function getPhoneYzm(data){
  return request({
    method: 'post',
    url: '/fenydata-java-console/api/0/v1//login/getVerifyCode',
    data,
  });
}
